var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShowPopupMakeAThon &&
    _vm.authenticated &&
    _vm.isShowPopupMakeAThonLS !== "0" &&
    _vm.$route.name !== "Guide" &&
    _vm.$route.name !== "IntroduceMobile"
    ? _c(
        "div",
        {
          staticClass: "modal fade show",
          staticStyle: { display: "block", "overflow-y": "scroll" },
          attrs: { id: "makeAThon", tabindex: "-1", "aria-hidden": "true" },
        },
        [
          _c(
            "div",
            {
              staticClass: "modal-dialog go-modal-notice",
              staticStyle: { "max-width": "700px" },
            },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c(
                  "div",
                  { staticClass: "modal-body", staticStyle: { padding: "0" } },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "go-img-area",
                        staticStyle: { cursor: "pointer" },
                        attrs: { href: _vm.url },
                      },
                      [
                        _c("img", {
                          staticStyle: { width: "100%", height: "100%" },
                          attrs: { src: _vm.imageSrc },
                        }),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "modal-footer",
                    staticStyle: { "margin-top": "0" },
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn go-btn-default",
                        attrs: { type: "button", "data-dismiss": "modal" },
                        on: { click: _vm.doNotShowAgain },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t(
                                "popupMakeAThon.footer.buttonText.notShowAgain"
                              )
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn go-btn-primary",
                        attrs: { type: "button", "data-dismiss": "modal" },
                        on: { click: _vm.handleCloseModal },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.$t("popupMakeAThon.footer.buttonText.close")
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                ),
              ]),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }